import { useEffect } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import initI18nDebug from '.'

// Initializes the i18n developer overlay once when the controlling flag is ON.

const useI18nDebug = () => {
  const flag = useFeatureFlag('discovery_i18n_overlay')
  useEffect(() => {
    if (flag?.isOn) initI18nDebug()
  }, [flag?.isOn])
}

export default useI18nDebug
